import { albumIdOf } from './transitions';

// Where the user is coming back from, so a list page can scroll back to the
// album (or Drive folder) they just left instead of opening at the top.
//
// AppRoot reports every real page change (link click in `useBeforeLeave`,
// back/forward in its capture-phase `popstate` handler) *before* the next page
// mounts. Only a "return" scrolls back: browser back/forward, or a link that
// explicitly slides back ("Terug naar index"). Any other link — the menu
// included — opens the page at the top. The list page takes the anchor once
// at mount.

// Element id to scroll to on the page being mounted, if it's a return.
let returnAnchor: string | null = null;

// The list-row id that represents the page at `key`: `album-{id}` for an album
// (AlbumListItem / AlbumCard), `album-{folder}` for a Drive folder (`/p/:folder`).
const anchorOf = (key: string): string | null => {
    const album = albumIdOf(key);
    if (album !== null) return `album-${album}`;
    const folder = key.match(/^\/p\/([^/?]+)/)?.[1];
    return folder ? `album-${folder}` : null;
};

export const recordPageChange = (fromKey: string, returning: boolean): void => {
    returnAnchor = returning ? anchorOf(fromKey) : null;
};

// Consumed on read, so only the page mounted by this navigation scrolls.
export const takeReturnAnchor = (): string | null => {
    const anchor = returnAnchor;
    returnAnchor = null;
    return anchor;
};
